module.exports = __webpack_public_path__ + "static/media/MIAB9191-180730-16_Small.b2eade99.jpg";